/* Sticky add to cart bar: slides in after a scroll distance (watched with IntersectionObserver, no scroll handler), follows the selected variant, and drives the main form. */
(() => {
  if (window.__ntStickyAtc) return;
  window.__ntStickyAtc = true;

  const bars = () => [...document.querySelectorAll('.nt-sticky')];
  const mainForm = (bar) => document.getElementById(bar.dataset.form);
  const mainIdInput = (bar) => mainForm(bar)?.querySelector('input[name="id"]');

  /* Visibility without reading layout: an invisible marker as tall as the threshold sits at the top of the page;
     once it has scrolled out of view the page is past the threshold. data-trigger="buybox": the bar also waits
     until the product info column (buy box) has left the viewport. */
  const pastLimit = new WeakMap();
  const atcInView = new WeakMap();
  const watch = (bar) => {
    if (bar.__ntWatched || !('IntersectionObserver' in window)) return;
    bar.__ntWatched = true;
    const marker = document.createElement('div');
    marker.setAttribute('aria-hidden', 'true');
    marker.style.cssText = 'position:absolute;top:0;left:0;width:1px;pointer-events:none;visibility:hidden;height:' + Math.max(1, parseInt(bar.dataset.threshold, 10) || 0) + 'px';
    document.body.appendChild(marker);
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => pastLimit.set(bar, !entry.isIntersecting && entry.boundingClientRect.bottom <= 0));
      toggle();
    }).observe(marker);
    if (bar.dataset.trigger !== 'buybox') return;
    const form = mainForm(bar);
    const atc = form?.closest('.product__info-container') || form?.querySelector('[name="add"]');
    if (!atc) return;
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => atcInView.set(bar, entry.isIntersecting));
      toggle();
    }, { rootMargin: '-72px 0px 0px 0px' }).observe(atc);
  };

  const toggle = () => {
    bars().forEach((bar) => {
      const hiddenByBuyBox = bar.dataset.trigger === 'buybox' && atcInView.get(bar) === true;
      bar.classList.toggle('is-visible', pastLimit.get(bar) === true && !hiddenByBuyBox);
    });
  };

  const syncFromMain = (bar) => {
    const input = mainIdInput(bar);
    if (!input) return;
    const select = bar.querySelector('[data-nt-sticky-select]');
    if (select && select.value !== input.value) select.value = input.value;
    const opt = select?.querySelector('option[value="' + input.value + '"]');
    const img = bar.querySelector('[data-nt-sticky-img]');
    if (img && opt && opt.dataset.image) { img.src = opt.dataset.image; img.removeAttribute('srcset'); }
    else if (img && !select) {
      // No picker in the bar: take the selected variant's image from the main gallery (active slide).
      const active = document.querySelector('#MediaGallery-' + bar.dataset.section + ' .product__media-item.is-active img');
      const src = active && (active.currentSrc || active.src);
      if (src && img.src !== src) { img.src = src; img.removeAttribute('srcset'); }
    }
    const price = document.getElementById('price-' + bar.dataset.section);
    const target = bar.querySelector('[data-nt-sticky-price]');
    if (price && target && price.innerHTML.trim()) target.innerHTML = price.innerHTML;
    const atc = mainForm(bar)?.querySelector('[name="add"]');
    const btn = bar.querySelector('.nt-sticky__btn');
    if (atc && btn) {
      const off = atc.hasAttribute('disabled');
      btn.toggleAttribute('disabled', off);
      if (off) btn.textContent = (atc.querySelector('span') || atc).textContent.trim();
      else if (btn.dataset.label && btn.textContent.trim() !== btn.dataset.label && !atc.hasAttribute('data-preorder')) btn.textContent = btn.dataset.label;
    }
  };

  const syncAll = () => bars().forEach(syncFromMain);

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (t && t.matches && t.matches('[data-nt-sticky-select]')) {
      const bar = t.closest('.nt-sticky');
      const wanted = (t.selectedOptions[0]?.dataset.options || '').split('||');
      const root = document.querySelector('variant-selects[data-section="' + bar.dataset.section + '"]') || document;
      let last = null;
      wanted.forEach((value, i) => {
        const radio = [...root.querySelectorAll('input[type="radio"]')].find((r) => r.name.trim().endsWith('-' + (i + 1)) && r.value === value);
        if (radio) { if (!radio.checked) radio.click(); return; }
        const sel = root.querySelector('#Option-' + bar.dataset.section + '-' + i);
        if (sel && sel.value !== value) { sel.value = value; last = sel; }
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (t && t.name === 'id') setTimeout(syncAll, 60);
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest && event.target.closest('.nt-sticky__btn');
    if (!btn || btn.disabled) return;
    const bar = btn.closest('.nt-sticky');
    mainForm(bar)?.querySelector('[name="add"]')?.click();
  });

  const init = () => { bars().forEach(watch); syncAll(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => bars().forEach(watch));
  [400, 1200].forEach((ms) => setTimeout(syncAll, ms));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => { setTimeout(syncAll, 50); setTimeout(syncAll, 400); });
  }
})();
